export const updateConcepts = (type) => (concepts) => {
    return {
        type,
        positive: concepts,
    }
}

export const removeMapping = (type) => (mapping) => ({
    type,
    mapping,
})

export const mappingPreviewRequest = (type) => (id, previewMapping) => ({
    type,
    id,
    previewMapping,
})

export const mappingPreviewResponse = (type) => (preview) => ({
    type,
    ...preview,
})

export const mappingPreviewErrorResponse = (type) => (
    error,
    id,
    previewMapping
) => ({
    type,
    error,
    id,
    previewMapping,
})
